import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-segmentos',
  templateUrl: './segmentos.component.html',
  styleUrls: ['./segmentos.component.scss']
})

export class SegmentosComponent implements OnInit  {
  data: any;
  
  constructor(
    private translate: TranslateService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
    });
  }

  ngOnInit() {
    this.carregarDados();
  }

  carregarDados() {
    this.translate.get('PRINCIPAL.PAGES.SEGMENTOS').subscribe(
      res => {
        this.data = res;
      });
  }
  
  onActivate(event) {
    window.scroll(0, 0);
  }
}
